/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_Project_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Project" |
*
* @param {Explorer_Display_Save_Project_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_project_button = /** @type {((inputs?: Explorer_Display_Save_Project_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Project_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट बचाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar projeto")
	return /** @type {LocalizedString} */ ("Save Project")
});